export default "__VITE_ASSET__DWQv6$_S__"